export default __webpack_public_path__ + "static/media/breakdown.014f8083.png";